import "./style.scss";
import { Button } from "antd";
import homeJson from "./productBanner.json";
import { iconsAndImages } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { openWhatsApp } from "../../utils";

export const ProductHome = () => {
    const navigate = useNavigate();
    return (
        <>
            <section className="home-product-bg d-flex align-items-center position-relative">
                <div className="container position-relative content-layer">
                    <div className="row align-items-center gy-4">

                        <div className="col-12 col-lg-7 text-center text-lg-start">
                            <h1
                                className="text-light home-title bebas-neue-regular pt-5 pt-md-0"
                                dangerouslySetInnerHTML={{ __html: homeJson?.mainCont }}
                            />

                            <p
                                className="text-light home-desc py-4"
                                dangerouslySetInnerHTML={{ __html: homeJson?.subCont }}
                            />

                            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                                <Button type="primary" size="large" onClick={() => navigate("/contact")}>
                                    {homeJson?.btnCont1}
                                </Button>
                            </div>
                        </div>

                        <div className="col-12 col-lg-5 d-flex justify-content-center">
                            <div className="blur-home-right rainbow-glass w-100">

                                <div className="d-flex align-items-center gap-3 py-3">
                                    <img loading="lazy" src={iconsAndImages[homeJson?.messageHomeIcon]} alt="" />
                                    <h5>{homeJson?.messageMainCont}</h5>
                                </div>

                                <p className="text-light">
                                    {homeJson?.messageSubCont}
                                </p>

                                <Button
                                    className="w-100 fw-bold py-4"
                                    onClick={() => openWhatsApp()}
                                >
                                    <img loading="lazy" src={iconsAndImages[homeJson?.messageRightIcon]} alt="" />
                                    {homeJson?.messageBtnConent}
                                </Button>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};
